<template>
  <div class="recharge">
    <!-- 积分扣减明细明细-->
    <el-dialog :title="$t('other.a2196')" :visible.sync="showChare" @close="$emit('update:intergralDia', false)"
      width="70%">
      <div style="padding:10px 0;font-size:18px">
        {{ $t('other.a2197') }}：<span>{{ totalDcePonit > 0 ? '+' : '' }}</span> {{ totalDcePonit }}
        <span class="num_desc">({{ $t('other.a2198') }})</span>

        <el-input size="small" style="width:250px;margin:0 8px " @change="getRecharge()" :placeholder="searplaceholder"
          v-model="orderId" clearable> </el-input>
      </div>
      <div style="width: 100%;">
        <div style="display:flex;">
          <div class="block">
            <el-date-picker v-model="value4" type="datetimerange" size="small" :picker-options="pickerOptions2"
              :range-separator="$t('other.a47')" :start-placeholder="$t('other.a45')" :end-placeholder="$t('other.a46')"
              @change="getRecharge()" format="yyyy-MM-dd" value-format="yyyy-MM-dd" align="right">
            </el-date-picker>
          </div>

          <div style="margin:0 15px">
            <el-select @change="getRecharge()" v-model="pay_Value" :placeholder="$t('other.a2199')" size="small">
              <el-option v-for="item in payTypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>

          </div>

          <div class="btn" style="margin-right:15px;display: flex;align-items: center;">
            <el-select size="small" v-model="timeValue" placeholder="请选择">
              <el-option :label="$t('other.a591')" :value="1">
              </el-option>
              <el-option :label="'推单时间'" :value="2">
              </el-option>
            </el-select>：
            <el-date-picker v-show="timeValue==1" size="small" v-model="value7" value-format="yyyy-MM-dd" @change="getRecharge()"
              type="daterange" :range-separator="$t('other.a47')" :start-placeholder="$t('other.a45')"
              :end-placeholder="$t('other.a46')">
            </el-date-picker>
            <el-date-picker v-show="timeValue==2" size="small" v-model="value8" value-format="yyyy-MM-dd" @change="getRecharge()"
              type="daterange" :range-separator="$t('other.a47')" :start-placeholder="$t('other.a45')"
              :end-placeholder="$t('other.a46')">
            </el-date-picker>
          </div>
          <div>
            <el-button size="small" type="primary" @click="exportXml()">{{ $t('other.a72') }}</el-button>
          </div>

        </div>
        <div>
          <el-table :data="pointsInfomation" height="350px" style="width: 100%">
            <el-table-column :label="$t('other.a2200')">
              <template slot-scope="props">
                <el-popover ref="popover4" placement="right" size="mini" trigger="hover">
                  <el-table size="mini" :data="props.row.orderDeductions">
                    <el-table-column width="150" property="orderId" :label="$t('other.a60')"></el-table-column>
                    <el-table-column width="60" property="orderFee" :label="$t('other.a2201')"></el-table-column>
                    <el-table-column width="180" property="desc" :label="$t('other.a2202')"
                      :show-overflow-tooltip="true"></el-table-column>

                  </el-table>
                </el-popover>
                <!-- <el-button size="mini" v-popover:popover4>{{$t('other.a600')}}</el-button> -->
                <span v-popover:popover4>{{ showChange(props.row.payType) }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('other.a60')">
              <template slot-scope="props">
                <span>{{ props.row.payOrderId }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('other.a1843')">
              <template slot-scope="props">
                <span>{{ props.row.changeIntegral }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('other.a2203')">
              <template slot-scope="props">
                <span>{{ props.row.oldIntegral }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('other.a2204')">
              <template slot-scope="props">
                <span>{{ props.row.newIntegral }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('other.a89')" :show-overflow-tooltip="true">
              <template slot-scope="props">
                <span>{{ getTiem(props.row.createTime) }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="'推单时间'" prop="needStock01" :show-overflow-tooltip="true">
              <template scope="scope">
                <span>{{ scope.row.auditTime ? getTiem(scope.row.auditTime) : scope.row.auditTime }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('other.a591')" prop="needStock01" :show-overflow-tooltip="true">
              <template scope="scope">
                <span>{{ scope.row.packagedTime }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('other.a1836')" :show-overflow-tooltip="true">
              <template slot-scope="props">
                <el-button size="mini" type="primary" @click="viewDetail(props.row)">{{ $t('other.a1835')
                  }}</el-button>
              </template>
            </el-table-column>

          </el-table>
          <div style="width: 100%;display: flex;justify-content: flex-end;margin-top:10px">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage4" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper" :total="pointsInfomationNum">
            </el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showChare = false">{{ $t('other.a5') }} </el-button>

      </span>
    </el-dialog>
    <!-- 预扣减积分明细-->
    <el-dialog :title="$t('other.a2206')" :visible.sync="Dia_Occupy" @close="$emit('update:intergralDia', false)"
      width="70%">
      <div style="width: 100%;">
        <div style="padding:10px 0;font-size:18px">{{ $t('other.a2132') }}：{{ widthHoldingpoints.toFixed(2) }}</div>
        <div style="display:flex">
          <div class="block">
            <el-date-picker v-model="value4" type="datetimerange" size="small" :picker-options="pickerOptions2"
              :range-separator="$t('other.a47')" :start-placeholder="$t('other.a45')" :end-placeholder="$t('other.a46')"
              @change="getOccupyPoint()" format="yyyy-MM-dd hh:mm:ss" value-format="yyyy-MM-dd" align="right">
            </el-date-picker>
          </div>
          <div style="margin-left:10px;display:flex">
            <el-input size="small" v-model="inputOrderId" :placeholder="$t('other.a764')" clearable></el-input>
            <div><el-button size="small" type="primary" @click="getOrder()">{{ $t('other.a2205') }}</el-button>
            </div>
          </div>
          <div style="margin:0 10px">
            <el-select @change="getOccupyPoint()" v-model="pay_Value" :placeholder="$t('other.a2199')" size="small">
              <el-option v-for="item in payTypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div>
            <el-button size="small" type="primary" @click="exportXmlCopy">{{ $t('other.a73') }}</el-button>
          </div>
        </div>
        <div>
          <el-table :data="OccupyList" height="350px" style="width: 100%">
            <el-table-column :label="$t('other.a2200')">
              <template slot-scope="props">
                <el-popover ref="popover1" placement="top-start" width="200" trigger="hover">
                  <el-table size="mini" :data="props.row.orderDeductions">
                    <el-table-column width="150" property="orderId" :label="$t('other.a60')"></el-table-column>
                    <el-table-column width="60" property="orderFee" :label="$t('other.a2201')"></el-table-column>
                    <el-table-column width="180" property="desc" :label="$t('other.a2202')"
                      :show-overflow-tooltip="true"></el-table-column>

                  </el-table>
                </el-popover>
                <span v-popover:popover1>{{ showChange(props.row.payType) }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('other.a60')">
              <template slot-scope="props">
                <span>{{ props.row.orderId }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('other.a588')">
              <template slot-scope="props">
                <span>{{ getTiem(props.row.payTime) }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('other.a686')">
              <template slot-scope="props">
                <span>{{ props.row.expectIntegral }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('other.a2207')" :show-overflow-tooltip="true">
              <template slot-scope="props">
                <span>{{ showShopName(props.row.shopId) }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('other.a2208')" :show-overflow-tooltip="true">
              <template slot-scope="props">
                <span>{{ showStoreName(props.row.storeId) }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('other.a89')" :show-overflow-tooltip="true">
              <template slot-scope="props">
                <span>{{ getTiem(props.row.createTime) }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('other.a1836')" :show-overflow-tooltip="true">
              <template slot-scope="props">
                <el-button size="mini" type="primary" @click="viewDetail(props.row)">{{ $t('other.a1835')
                  }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="width: 100%;display: flex;justify-content: flex-end;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage4" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper" :total="OccupyCount">
            </el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="Dia_Occupy = false">{{ $t('other.a5') }} </el-button>

      </span>
    </el-dialog>
    <!-- 扣费明细-->
    <el-dialog :title="$t('other.a1835')" :visible.sync="rechargDatil" @close="$emit('update:intergralDia', false)"
      width="60%">
      <div style="width: 100%;">
        <el-table size="mini" height="450" border :data="orderDeductions">
          <el-table-column width="150" property="orderId" :label="$t('other.a60')"
            :show-overflow-tooltip="true"></el-table-column>
          <el-table-column width="120" property="orderFee" :label="$t('other.a2201')"
            :show-overflow-tooltip="true"></el-table-column>
          <el-table-column property="desc" :label="$t('other.a2202')" :show-overflow-tooltip="true"></el-table-column>
          <!-- <el-table-column width="180"   label="是否预占" :show-overflow-tooltip="true">
					<template slot-scope="props">
						<span>{{props.row.type}}</span>
					</template>
				</el-table-column> -->

        </el-table>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="rechargDatil = false">{{ $t('other.a5') }} </el-button>

      </span>
    </el-dialog>
    <Qrcode-Dialog :show.sync="show" :qrCode="qrCode" :qrCodePrice="qrCodePrice" :payParams="payParams"
      @refreshPoint='refreshPoint' />
    <Dialog :billvis.sync="billvis"></Dialog>
    <Dialog :intergralDia.sync="intergralDia"></Dialog>
    <div class="recharge-box">
      <div style="display: flex;justify-content: space-between;">
        <div>
          <span style="padding-left: 20px;margin-right: 20px;">{{ $t('other.a2209') }}：{{
            actualIntegral.toFixed(1) }}</span>
          <span style="padding-left: 20px;margin-right: 20px;">{{ $t('other.a2210') }}：{{
            usableIntegral.toFixed(1) }}</span>
          <span style="padding-left: 20px;margin-right: 20px;">{{ $t('other.a2132') }}：{{
            expectIntegral.toFixed(1) }}</span>
          <el-button size="medium" type="primary" @click="getRecharge()">{{ $t('other.a2211') }}</el-button>
          <el-button size="medium" type="primary" @click="getOccupyPoint()">{{ $t('other.a2212') }}</el-button>
        </div>
      </div>

      <div id="_san_127" class="module-line"
        style="color: #4c4c4c;margin-top:40px; margin-bottom:10px;text-align: center;font-size: 26px;">
        <span id="_san_131" class="text">{{ $t('other.a2213') }} </span>
      </div>
      <div class="recharge-wrapper">
        <div class="recharge-item" @mouseenter="changeActive($event)" @mouseleave="removeActive($event)"
          v-for="(item, index) in payOptions" :key="index">
          <div id="_san_248" style="text-align: center;">
            <span class="commodity-type">{{ item.payFee }}</span><span id="_san_256">{{ $t('other.a157') }}/{{
              item.gainIntegral }}{{ $t('other.a54') }}</span>
          </div>
          <div id="_san_260" class="commodity-buy-btn">
            <p class="center-button-base center-button-yellow center-button-container-middle"
              @click="createPayorder(item)">
              {{ $t('other.a1071') }}</p>
          </div>
        </div>
      </div>
      <div style="margin: 30px 0 0 15px;">{{ $t('other.a2214') }}</div>
    </div>

  </div>
</template>

<script>
import QrcodeDialog from '../../components/dialog/qrcodeDialog.vue'
import Dialog from '../../components/dialog/dialog.vue'
import utils from '../../utils/utils.js'
import api from '../../api/moudles/deduction'
import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex'
export default {
  data() {
    return {
      price: '0',
      oop: false,
      input10: '',
      whchatpay: '1',
      storeIds: JSON.parse(localStorage.getItem('userInfo')).storeIds,
      shopIdsCopy: JSON.parse(localStorage.getItem('userInfo')).shopIds,
      pagesize: 50,
      page: 0,
      show: false,
      payParams: null,
      billvis: false,
      point: JSON.parse(localStorage.getItem('userInfo')).userIntegral,
      intergralDia: false,
      pointsInfomation: [],
      pointsInfomationNum: 0,
      orderDeductions: [],
      showChare: false,
      Dia_Occupy: false,
      OccupyList: [],
      OccupyCount: 0,
      inputOrderId: '',
      rechargDatil: false,
      currentPage4: 1,
      flag: null,
      payOptions: [],
      totalDcePonit: 0,
      widthHoldingpoints: 0,
      pickerOptions2: {
        shortcuts: [{
          text: this.$t("other.a130"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t("other.a131"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t("other.a132"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      payTypeOptions: [],
      value4: [],
      value7: [],
      timeValue:1,
      value8: [],
      pay_Value: null,
      shopIds: [],
      searplaceholder: this.$t("allorders.lookup"),
      orderId: null,
    }
  },
  components: {
    QrcodeDialog,
    Dialog
  },
  computed: {
    ...mapState({
      userId: state => state.login.userInfo.userId || '',
      qrCode: state => state.recharge.qrCode,
      qrCodePrice: state => state.recharge.qrCodePrice,
      isChecked: state => state.recharge.isChecked,
      integral: state => state.recharge.integral,
      actualIntegral: state => state.recharge.actualIntegral,
      expectIntegral: state => state.recharge.expectIntegral,
      usableIntegral: state => state.recharge.usableIntegral,


    }),

  },
  watch: {
    inputOrderId() {
      if (this.inputOrderId == '') {
        this.getOccupyPoint()
      }
    },
    isChecked() {
      if (this.isChecked) {
        this.show = false
        this.getSellerPoint({
          userId: this.userId
        })

      }
    }
  },
  created() {
    this.payTypeOptions = utils.chargeNameOptions()
    this.refreshIntegral()//获取用户积分
    this.getRechargeRules()

  },
  methods: {
    ...mapActions('recharge', [
      'createOrderalipay',
      'OrderTracking',
      'pointChange',
      'getSellerPoint'

    ]),
    ...mapMutations('recharge', [
      'REMOVE_STATE_T',
    ]),

    refreshPoint() {
      this.getSellerPoint({
        userId: this.userId
      })

    },

    viewDetail(item) {
      console.log(item)
      this.orderDeductions = item.orderDeductions
      this.rechargDatil = true
    },
    getRechargeRules() {
      api
        .getUserRechargeRule()
        .then(res => {
          if (res.code === 200) {
            if (res.data) {
              console.log('收款规则', res.data)
              let list = [1999, 2999, 4999, 5999, 19999]
              this.payOptions = res.data.filter(p => {
                if (list.indexOf(p.payFee) == -1) {
                  return p
                }
              })
            }

          }
        })
    },


    getOrder() {
      console.log(this.inputOrderId)
      api
        .getDeductionOrder({ orderId: this.inputOrderId })
        .then(res => {
          if (res.code === 200) {
            if (res.data) {
              console.log('预扣积分明细', res.data)
              this.OccupyList = [res.data]
              this.OccupyCount = this.OccupyList.length
              this.widthHoldingpoints = res.data.expectIntegral
            } else {
              this.$message.error(this.$t('other.a2215'))
            }

          }
        })
    },

    //查看占用积分
    getOccupyPoint() {
      console.log(this.value4)
      let params = {
        payType: this.pay_Value,
        offset: this.pagesize,
        page: this.page,
        shopIds: this.shopIdsCopy,
        storeIds: this.storeIds,
        end: this.value4[1].slice(0, 10),
        start: this.value4[0].slice(0, 10),
        userId: this.userId

      }
      this.Dia_Occupy = true
      this.flag = 1
      api
        .getExceptIntegralLog(params)
        .then(res => {
          if (res.code === 200) {
            console.log('预扣积分明细', res.data)
            this.OccupyList = res.data.deductions
            this.OccupyCount = res.data.count
            this.widthHoldingpoints = res.data.feeCount
          }
        })

    },

    //获取积分变化明细
    getRecharge() {
      let params = {
        payType: this.pay_Value,
        offset: this.pagesize,
        page: this.page,
        shopIds: this.shopIdsCopy,
        storeIds: this.storeIds,
        end: utils.CurdateAddoneday(this.value4[1].slice(0, 10)),
        start: this.value4[0].slice(0, 10),
        userId: this.userId,
        startPackagedTime: this.value7 && this.value7.length > 0 ? this.value7[0] : null,
        endPackagedTime: this.value7 && this.value7.length > 0 ? utils.CurdateAddoneday(this.value7[1]) : null,
        startAuditTime: this.value8 && this.value8.length > 0 ? this.value8[0] : null,
        endAuditTime: this.value8 && this.value8.length > 0 ? utils.CurdateAddoneday(this.value8[1]) : null
      }
      this.showChare = true
      this.flag = 0
      let orderId = JSON.parse(JSON.stringify(this.orderId))

      if (orderId && orderId != '') {
        let value = JSON.parse(JSON.stringify(orderId)).trim()
        params.orderId = value
        if (value.includes(' ')) {
          params.orderIds = value.split(' ')
          if (params.orderIds.length > 200) {
            this.$message.warning(this.$t('other.a3374'))
            return
          }
          params.orderId = ''
        } else {
          params.orderIds = [value]
        }
      }

      api
        .getIntegralLog(params)
        .then(res => {
          if (res.code === 200) {
            console.log('收入支出', res.data)
            res.data.logs.forEach(p => {
              if (p.packagedTime) {
                p.packagedTime = this.TimeTrans(p.packagedTime)
              }
            })
            this.pointsInfomation = res.data.logs
            this.pointsInfomationNum = res.data.count
            this.totalDcePonit = res.data.feeCount


          }
        })
    },
    TimeTrans(timestamp) {
      let date = new Date(new Date(timestamp).getTime() + 8 * 3600 * 1000)
      date = date.toJSON();
      date = date.substring(0, 19).replace('T', ' ')
      return date
    },

    getTiem(time) {
      return utils.renderTime(time)
    },

    showChange(id) {
      let ttp = null
      let oop = this.payTypeOptions.find(item => item.value == id)
      if (oop) {
        ttp = oop.label
      } else {
        ttp = id
      }


      return ttp
    },

    showStoreName(id) {
      return utils.showstoreNameBystoreId(id)
    },
    showShopName(id) {
      return utils.showshopNameByshopIdOne(id)
    },

    showPrams(item) {
      console.log(item)
    },

    refreshIntegral() {
      this.getSellerPoint({
        userId: this.userId
      })
      this.value4 = [utils.getRecentSevenDay(-30), utils.getRecentSevenDay(1)]
      this.shopIds = utils.getAllshop().slice(1).map(p => {
        return p.value
      })

      console.log(this.shopIds)
    },
    checkPoints() {
      let params = {
        sortType: 1,
        page: 0,
        offset: 15,
        searchCreateBeginTime: utils.getchinastadarTime(-7),
        searchCreateEndTime: utils.getchinastadarTime(0),
        userId: this.userId,
      }
      console.log(params)
      this.pointChange(params)
      this.intergralDia = true
    },
    //导出全部已扣减积分
    exportXml() {
      let params = {
        payType: this.pay_Value,
        offset: this.pointsInfomationNum + 1,
        page: 0,
        shopIds: this.shopIdsCopy,
        storeIds: this.storeIds,
        end: utils.CurdateAddoneday(this.value4[1].slice(0, 10)),
        start: this.value4[0].slice(0, 10),
        userId: this.userId,
        startPackagedTime: this.value7 && this.value7.length > 0 ? this.value7[0] : null,
        endPackagedTime: this.value7 && this.value7.length > 0 ? utils.CurdateAddoneday(this.value7[1]) : null,
        startAuditTime: this.value8 && this.value8.length > 0 ? this.value8[0] : null,
        endAuditTime: this.value8 && this.value8.length > 0 ? utils.CurdateAddoneday(this.value8[1]) : null
      }
      let orderId = JSON.parse(JSON.stringify(this.orderId))

      if (orderId && orderId != '') {
        let value = JSON.parse(JSON.stringify(orderId)).trim()
        params.orderId = value
        if (value.includes(' ')) {
          params.orderIds = value.split(' ')
          if (params.orderIds.length > 200) {
            this.$message.warning(this.$t('other.a3374'))
            return
          }
          params.orderId = ''
        } else {
          params.orderIds = [value]
        }
      }
      console.log('params', params)




      api
        .getIntegralLog(params)
        .then(res => {
          if (res.code === 200) {
            let arr = []
            res.data.logs.forEach(p => {
              arr.push({
                '支付类型': this.showChange(p.payType),
                '支付单号': p.payOrderId,
                // '下单时间': this.getTiem(p.payTime),
                // '预扣积分': p.expectIntegral,
                '支出方（商店）': p.shopName,
                '收入方（仓库）': this.showStoreName(p.storeId),
                '支付积分': p.changeIntegral,
                '积分变化前': p.oldIntegral,
                '积分变化后': p.newIntegral,
                '时间': utils.getCurrnetTime(p.createTime),
                '推单时间': p.auditTime ? utils.getCurrnetTime(p.auditTime) : p.auditTime,
                '出库时间': p.packagedTime ? this.TimeTrans(p.packagedTime) : p.packagedTime,
              })
            })
            let list = ['支付类型', '支付单号', '支出方（商店）', '收入方（仓库）',  '支付积分', '积分变化前', '积分变化后', '时间', '推单时间', '出库时间']
            let tip = 'DeductionPoints'
            utils.exPortEXml(arr, list, tip)
          }
        })

    },
    //导出全部预扣积分
    exportXmlCopy() {
      let params = {
        payType: null,
        offset: null,
        page: 0,
        shopIds: null,
        storeIds: null,
        end: this.value4[1].slice(0, 10),
        start: this.value4[0].slice(0, 10),
        userId: this.userId
      }
      api
        .getExceptIntegralLog(params)
        .then(res => {
          if (res.code === 200) {
            let arr = []
            res.data.deductions.forEach(p => {
              arr.push({
                '支付类型': this.showChange(p.payType),
                '支付单号': p.orderId,
                '下单时间': this.getTiem(p.payTime),
                '预扣积分': p.expectIntegral,
                '支出方（商店）': this.showShopName(p.shopId),
                '收入方（仓库）': this.showStoreName(p.storeId),
                '时间': p.createTime,
              })
            })
            let list = ['支付类型', '支付单号', '下单时间', '预扣积分', '支出方（商店）', '收入方（仓库）', '时间']
            let tip = 'WithholdingPoints'
            utils.exPortEXml(arr, list, tip)
          }
        })

    },

    viewBills() {

      let params = {
        platform: -1,
        orderStatus: '',
        sortType: 5,
        gmtCreateSearchBeginTime: utils.getchinastadarTime(-7),
        gmtCreateSearchEndTime: utils.getchinastadarTime(0),
        userId: this.userId,
      }
      console.log(params)
      this.OrderTracking(params)
      this.billvis = true
    },
    selectPrice() {
      console.log(this.qrCode)
      if (this.price === '自定义充值') {
        this.oop = true
      } else {
        this.oop = false
      }
    },
    createPayorder(item) {
      let params = {
        rechargeId: item.rechargeId,
        userId: this.userId
      }

      this.payParams = {
        userId: this.userId,
        rechargeId: item.rechargeId,
        price: item.payFee
      }
      this.createOrderalipay(params)
      this.show = true
    },
    tto() {
      this.REMOVE_STATE_T()
    },
    changeActive($event) {
      $event.currentTarget.className = "recharge-item ttp"
    },
    removeActive($event) {
      $event.currentTarget.className = "recharge-item"
    },
    handleSizeChange(val) {
      this.pagesize = Number(`${val}`)
      console.log('每面显示的数量', this.pagesize);
      this.handleCurrentChange()
    },
    handleCurrentChange(val) {
      let num = Number(`${val}`)
      this.page = (num - 1) * this.pagesize
      if (this.flag == 0) {
        this.getRecharge()
      } else if (this.flag == 1) {
        this.getOccupyPoint()
      }

    },
  }
}
</script>

<style lang="scss" scoped>
.recharge {
  width: 100%;
  // padding: 30px 0 0 221px;
  overflow: hidden;

  .ttp {
    transform: scale(1.08);
  }

  .num_desc {
    color: red;
    font-size: 12px;
    margin: 0 20px;
  }

  .recharge-box {
    box-sizing: border-box;
    margin: 30px;


    .recharge-wrapper {
      display: flex;
      margin-bottom: 60px;
      flex-wrap: wrap;
      justify-content: center;


      .recharge-item {
        width: 242px;
        height: 220px;
        box-shadow: rgba(0, 0, 0, .1) 0 0 25px;
        margin: 19px;
        transition: all 0.5s;
        cursor: pointer;


        .commodity-type {
          display: inline-block;
          font-size: 36px;
          color: #ca963b;
          margin-top: 56px;
          text-align: center;
        }

        .commodity-buy-btn {
          margin-top: 26px;
          margin-left: 56px;
        }

        .center-button-container-middle {
          width: 120px;
          height: 30px;
          font-size: 14px;
          line-height: 30px;
          text-align: center;
          border-radius: 15px;
        }

        .center-button-yellow {
          border: 1px solid #ca963b;
          color: #ca963b;
        }

        .center-button-base {
          cursor: pointer;
          display: inline-block;
          *display: inline;
          margin: 0 5px;
          *zoom: 1;
        }


      }
    }

  }
}


/* .recharge{
		flex: 1;
		
		padding: 60px 0 0 221px;
		
		width: 100%;
	
		
		
	}

	.price-input{
		margin:20px 86px;
		width: 250px;
		border-radius: 40px;
	}
	
	.recharge-item{
		width: 242px;
		height: 220px;
		box-shadow: rgba(0,0,0,.1) 0 0 25px;
		margin: 19px ;
		transition: all 0.5s;
		cursor: pointer;
	}
	

	
	.recharge-wrapper{
		display: flex;
		justify-content: center;
		margin-bottom: 60px;
		
	}
	

	
	.commodity-price-svip-box{
		    margin-top: 12px;
		    text-align: center;
		    font-size: 14px;
	}
	.commodity-price-svip{
		        font-size: 24px;
		        color: #ca963b;
	}
	

	
	
	
	
	 */
</style>
